const handleCustomForm = () => {  
  const customForm = document.querySelector('[data-custom-form]');
  const customSubmit = customForm.querySelector('[data-custom-form-submit]');
  customSubmit.addEventListener('click', (e) => {
    e.preventDefault()

    // submit form to sheetmonkey https://docs.sheetmonkey.io/guides/building-a-javascript-form-with-sheet-monkey
    // test sheet: https://docs.google.com/spreadsheets/d/1NE6GYpdHtwPGN2ucUT2XSsqP3Zn46_cpJlugz8oLjYo/edit#gid=0
    // test action: https://api.sheetmonkey.io/form/xun7i6CrkwGKGitA2PhFTw
    const formElement = e.target.closest('form')
    const formData = new FormData(formElement);
    const data = Object.fromEntries(formData.entries());
    // console.log(JSON.stringify(data));
    const formAction = formElement.action;

    if ( formAction.toLowerCase().indexOf('ignore') >= 0 ) {
      // if they add ignore into the name of the form action
      // then just show the success messaging
      formElement.classList.add('hide');
      document.querySelector('[data-successful]').classList.remove('hide');

    } else {

      fetch(formAction, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then((result) => {
        // Handle the result
        if (result && result?.status === 200) {
          formElement.classList.add('hide')
          document.querySelector('[data-successful]').classList.remove('hide')
        } else {
          console.log(result)
        }
      });
    }

    // If we have an Email - submit form data to bloomReach - needed?

    if (data['email']) {
      const timestamp = parseInt(Date.now()/1000)

      const identifyObject = {
        'email': data['email']
      }

      window['exponea'].identify(
        { 'email_id': data['email'] },
        identifyObject
      );
      customForm.querySelectorAll('[data-br]').forEach(bloomReachEntry => {
        const fieldName = bloomReachEntry.name
        identifyObject[fieldName] = data[fieldName];
      })
      window['exponea'].track('form_signup', identifyObject);

      if (data['marketing-consent'] && data['marketing-consent'] === 'agreed_to_marketing') {
        window['exponea'].track('consent', {
          action: 'accept',
          category: 'email',
          // eslint-disable-next-line camelcase
          valid_until: 'unlimited',
          placement: 'Custom Form',
          timestamp: timestamp
        });
      }
    }
  });
}

export default handleCustomForm;